// extracted by mini-css-extract-plugin
export default {"bgColorWarning":"#ff877f","whiteColor":"#fff","topPanel":"TopPanel_topPanel__K7aW8","topPanel__filtersIcon":"TopPanel_topPanel__filtersIcon__VCjLQ"};